import { AxiosError, AxiosResponse, default as axios } from 'axios';
import { InvitationsSettings, Template } from '../Model';
import { Auth } from '@trustpilot/ecommscript-integrationappauth';
import { logError } from './ecommscriptClient';
import { Tools } from '../Tools';

const api = `${process.env.REACT_APP_InvitationsSettingsApiUrl}/v1/private/business-units`;

export const saveInvitationSettings = (businessUnitId: string, invitationsSettings: InvitationsSettings): Promise<boolean> => {
    const headers = {
        'Authorization': `Bearer ${Auth.getAccessToken()}`,
        'Content-Type': 'application/json',
    };
    return axios
        .put(`${api}/${businessUnitId}/invitation-settings`, invitationsSettings, { headers })
        .then(() => {
            return true;
        }).catch((err: AxiosError) => {
            logError({
                message: `Failed on saveInvitationSettings with BUID ${businessUnitId}, invitations settings ${JSON.stringify(invitationsSettings)} and request headers ${JSON.stringify(headers)}`,
                error: JSON.stringify(err)
            });
            Tools.resetTokenIfUnauthorized(err.response);
            return false;
        });
};

interface TemplateResponse {
    templates: Template[];
}

export const loadTemplates = (businessUnitId: string): Promise<Template[] | undefined> => {
    const headers = {
        'Authorization': `Bearer ${Auth.getAccessToken()}`,
        'Content-Type': 'application/json',
    };
    return axios
        .get(`${api}/${businessUnitId}/templates`, { headers })
        .then((response: AxiosResponse<TemplateResponse>) => {
            return response.data.templates;
        }).catch((err: AxiosError) => {
            logError({
                message: `Failed on loadTemplates with BUID ${businessUnitId} and request headers ${JSON.stringify(headers)}`,
                error: JSON.stringify(err)
            });
            Tools.resetTokenIfUnauthorized(err.response);
            return undefined;
        });
};

export const getInvitationSettings = (businessUnitId: string): Promise<InvitationsSettings | undefined> => {
    const headers = {
        'Authorization': `Bearer ${Auth.getAccessToken()}`,
        'Content-Type': 'application/json',
    };
    return axios
        .get(`${api}/${businessUnitId}/invitation-settings`, { headers })
        .then((response: AxiosResponse<InvitationsSettings>) => response.data)
        .catch((err: AxiosError) => {
            logError({
                message: `Failed on getInvitationSettings with BUID ${businessUnitId} and request headers ${JSON.stringify(headers)}`,
                error: JSON.stringify(err)
            });
            Tools.resetTokenIfUnauthorized(err.response);
            return undefined;
        });
};

export const sendTestInvitation = async (businessUnitId: string, data: object): Promise<boolean> => {
    const headers = {
        'Authorization': `Bearer ${Auth.getAccessToken()}`,
        'Content-Type': 'application/json',
    };
    return axios
        .post(`${api}/${businessUnitId}/send-test-invitation`, data, { headers })
        .then(() => true)
        .catch((err: AxiosError) => {
            logError({
                message: `Failed on sendTestInvitation with BUID ${businessUnitId} and request headers ${JSON.stringify(headers)}`,
                error: JSON.stringify(err)
            });
            Tools.resetTokenIfUnauthorized(err.response);
            return false;
        });
};



// WEBPACK FOOTER //
// ./src/Api/invitationSettingsClient.ts